module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bgYcg"))).then(() => parcelRequire('dJXJK'));